import { IMultipleIdsParams } from '../types/actionParams';
import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export interface ISetMetricsSuspendedStateParams extends IMultipleIdsParams {
    isSuspended: boolean;
}

export class SetMetricsSuspendedStateRequest extends Request<ISetMetricsSuspendedStateParams, IEmptyResult> {
  constructor(isSuspended: boolean, ids: string[]) {
    super('setMetricsSuspendedState', { isSuspended: isSuspended, ids: ids });
  }
}
